const map =
{
    close : 'Fermer' ,
    map   :
    {
        attribution : 'XYZ by <a href="https://www.ooopener.com">Ooopener</a>'
    }
};

export default map ;


// WEBPACK FOOTER //
// ./src/app/locale/fr/views/map.js